import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=b4dbcb6e&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=ts"
export * from "./Goods.vue?vue&type=script&lang=ts"
import style0 from "./Goods.vue?vue&type=style&index=0&id=b4dbcb6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dbcb6e",
  null
  
)

export default component.exports